import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/customer.css';

// A dead button tells you nothing. Any uncaught error now paints itself across the top of the
// page, so a fault can be read off the screen instead of guessed at from a description.
function showError(what: string, where: string) {
  let bar = document.getElementById('ymcCrash');
  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'ymcCrash';
    bar.style.cssText =
      'position:fixed;top:0;left:0;right:0;z-index:9999;background:#b3261e;color:#fff;' +
      'font:600 12.5px/1.45 ui-monospace,SFMono-Regular,Menlo,monospace;padding:10px 14px;' +
      'white-space:pre-wrap;max-height:40vh;overflow:auto;box-shadow:0 2px 10px rgba(0,0,0,.3)';
    document.body.appendChild(bar);
  }
  bar.textContent = (bar.textContent ? bar.textContent + '\n' : '') + what + (where ? '  @ ' + where : '');
}

(window as any).__ymShowError = showError;

window.addEventListener('error', (e) => {
  showError(e.message || String(e.error || 'error'), (e.filename || '').split('/').pop() + ':' + e.lineno);
});
window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
  const r: any = e.reason;
  showError('Unhandled: ' + ((r && r.message) || String(r)), '');
});

// StrictMode deliberately double-invokes effects in development. The Stage 1 code is imperative
// and mounts into the DOM once, so a second invocation would attach every listener twice. It goes
// back in as each piece becomes a real component in Stage 2.
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
